export { default as colors } from './colors'
export { default as path } from './path'
export { default as setDocTitle } from './setDocTitle'
